
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/3catinfo/el-temps/[slug]/previsio/[id]",
      function () {
        return require("private-next-pages/3catinfo/el-temps/[slug]/previsio/[id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/3catinfo/el-temps/[slug]/previsio/[id]"])
      });
    }
  